/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import React, { Component } from 'react';
import {
  Button,
  ButtonToolbar,
  Label,
  Input,
  FormGroup,
  Modal,
  ModalBody,
  Col,
  Row
} from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { validateEmail } from '../../../helper/functions';
// import BasicNotification from './Notifications/BasicNotification';

class AddClientModal extends Component {
  static defaultProps = {
    title: '',
    message: '',
    colored: false,
    header: false,
    selectedOption: null,
  };

  state = {
    isCompany: false,
    clientExist: false
  }

  searchClientRender = () => {

    const {
      onChangeInput,
      value,
      onSubmitSearch,
      isRUTValid,
      toggle,
      unknownError,
      toggleClientExists,
      clientFound,
      clientInPortal,
      clientNotFound
    } = this.props;

    return (
      <form className="form form--horizontal">
        <ModalBody>
          <FormGroup style={{ textAlign: 'left' }}>
            <Label className="label_autofin" for="rut">RUT</Label>
            <Input
              type="text"
              name="rut"
              id="rut"
              value={value.rut}
              invalid={!isRUTValid(value.rut)}
              onChange={onChangeInput('rut')}
              required
              style={{ marginBottom: '20px' }}
            />
            <span hidden={!clientNotFound} style={{ color: '#FF0000' }}>Este cliente no está registrado en Trinidad</span>
            <span hidden={clientFound} style={{ color: '#FF0000' }}>Este cliente no está registrado en portal cliente</span>
            <span hidden={!clientInPortal} style={{ color: '#008f39' }}>Este cliente ya está registrado en portal cliente</span>
            <span hidden={!unknownError} style={{ color: '#FF0000' }}>Error desconocido</span>
          </FormGroup>
        </ModalBody>
        <ButtonToolbar className="modal__footer" style={{ justifyContent: 'center' }}>
          <Button className="asignar" onClick={toggle}>Cancelar</Button>{' '}
          <Button
            className="asignar just_this"
            onClick={onSubmitSearch}
            disabled={!isRUTValid(value.rut) || !value.rut ? true : false}
            id="added"
          >Buscar</Button>

          <Button
            className="asignar just_this"
            onClick={toggleClientExists}
            hidden={clientFound}
            id="added"
          >Agregar Cliente</Button>
        </ButtonToolbar>
      </form>
    );
  }

  addClientRender = () => {

    const {
      onChangeInput,
      value,
      onSubmitAddClient,
      isRUTValid,
      toggle,
      unknownError
    } = this.props;
    return (
      <form className="form form--horizontal">
        <ModalBody>
          <FormGroup style={{ textAlign: 'left' }}>
            {this.state.isCompany ?
              (<>
                <Label className="label_autofin" for="nameCompany">Nombre Empresa</Label>
                <Input
                  type="text"
                  name="nameCompany"
                  id="nameCompany"
                  value={value.nameCompany}
                  onChange={onChangeInput('nameCompany')}
                  required
                  style={{ marginBottom: '20px' }}
                />
              </>)
              :
              (<>
                <Label className="label_autofin" for="name">Nombres</Label>
                <Input
                  type="text"
                  name="name"
                  id="name"
                  value={value.name}
                  onChange={onChangeInput('name')}
                  required
                  style={{ marginBottom: '20px' }}
                />
                <Row>
                  <Col md='6'>
                    <Label className="label_autofin" for="lastname">Apellido Paterno</Label>
                    <Input
                      type="text"
                      name="lastname"
                      id="lastname"
                      value={value.lastname}
                      onChange={onChangeInput('lastname')}
                      required
                      style={{ marginBottom: '20px' }}
                    />
                  </Col>

                  <Col md='6'>
                    <Label className="label_autofin" for="lastnameM">Apellido Materno</Label>
                    <Input
                      type="text"
                      name="lastnameM"
                      id="lastnameM"
                      value={value.lastnameM}
                      onChange={onChangeInput('lastnameM')}
                      required
                      style={{ marginBottom: '20px' }}
                    />
                  </Col>
                </Row>
              </>)
            }
            <Label className="label_autofin" for="rut">RUT</Label>
            <Input
              type="text"
              name="rut"
              id="rut"
              value={value.rut}
              invalid={!isRUTValid(value.rut)}
              onChange={onChangeInput('rut')}
              required
              style={{ marginBottom: '20px' }}
            />
            <Label className="label_autofin" for="email">Email</Label>
            <Input
              type="text"
              name="email"
              id="email"
              invalid={!validateEmail(value.email)}
              value={value.email}
              onChange={onChangeInput('email')}
              required
              style={{ marginBottom: '20px' }}
            />
            {/* <span hidden={hideNewClient} style={{ color: '#FF0000' }}>Este contacto ya está registrado</span> */}
            <span hidden={!unknownError} style={{ color: '#FF0000' }}>Error desconocido</span>
          </FormGroup>
        </ModalBody>
        <ButtonToolbar className="modal__footer" style={{ justifyContent: 'center' }}>
          <Button className="asignar" onClick={toggle}>Cancelar</Button>{' '}
          <Button
            className="asignar just_this"
            onClick={onSubmitAddClient}
            disabled={!isRUTValid(value.rut) || !value.rut ? true : false || !validateEmail(value.email)}
            id="added"
          >Agregar
          </Button>
        </ButtonToolbar>
      </form>
    );
  }

  render() {
    const {
      title,
      isOpen,
      toggle,
      clientExist,
    } = this.props;

    return (
      <div>
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          className="modal-add-client modal-dialog--success"

        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            {(!clientExist) ?
              (<h2 className="bold-text label_autofin  modal__title" style={{ fontWeight: 'bold', textAlign: 'left' }}> <strong>Buscar Cliente Trinidad</strong></h2>)
              :
              (<Row>
                <Col md='8'>
                  <h2 className="bold-text label_autofin  modal__title" style={{ fontWeight: 'bold', textAlign: 'left' }}> <strong>{title}</strong></h2>
                </Col>
                <Col md='4'>
                  <Button
                    className={this.state.isCompany ? 'asignar' : 'asignar just_this'}
                    onClick={() => { this.setState({ isCompany: !this.state.isCompany }) }}
                    id="isCompany"
                  >{this.state.isCompany ? 'Persona' : 'Empresa'}
                  </Button>
                </Col>
              </Row>)
            }
          </div>
          {clientExist ? this.addClientRender() : this.searchClientRender()}

        </Modal>
      </div>
    );
  }
}

export default AddClientModal;
